<template>
    <div class="Groupclients">
        <div class="header">
            <el-row>
                <el-col :span="7">
                    <label class="headerlabel">机构名称</label>
                    <el-input v-model="param.Name" placeholder="请输入用户账号/姓名" class="autowidth" clearable></el-input>
                </el-col>
                <el-col :span="7">
                    <label class="headerlabel">预约主题</label>
                    <el-select v-model="param.ConsultTheme" placeholder="请选择主题" filterable  class="autowidth" clearable >
                        <el-option v-for="item in theme" :label="item" :value="item"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="10">
                    <label class="headerlabel">有效时间</label>
                    <el-date-picker    
                    class="autowidth"
                    clearable
                    v-model="Finalpaymenttime"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                    </el-date-picker>
                    <el-button type="primary" style="margin-left: 24px;" @click="init">筛选</el-button>
                    <el-button @click="reset">重置条件</el-button>
                </el-col>
            </el-row>
        </div>

        <main class="MainContent">
            <el-button type="primary" style="margin-bottom: 10px;" @click="dialogVisible=true">新建团体诉求</el-button>
            <el-table
            :data="GroupdemandsData"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            style="width: 100%;margin-bottom: 20px;">
                <el-table-column prop="creator" label="账号"></el-table-column>
                <el-table-column prop="consultTheme" label="预约主题"></el-table-column>
                <!-- <el-table-column prop="memberLevelStr" label="咨询方式"></el-table-column> -->
                <el-table-column prop="servicePrice" label="场次价格"></el-table-column>
                <el-table-column prop="effectiveDate" label="有效日期"></el-table-column>
                <el-table-column prop="createDate" label="创建时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" style="margin-right: 10px;" @click="ClickAudit(scope.row)">编辑</el-button>
                        <el-popconfirm title="是否确定删除？" @confirm="confirm(scope.row)">
                            <el-button type="text" style="color: #F24B4E;" slot="reference">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
            :hide-on-single-page=true
            @current-change="handleinitialization"
            :current-page.sync="param.pageIndex"
            :page-size="param.pageSize"
            layout="total, prev, pager, next"
            :total="param.PageTotal">
        </el-pagination>
        </main>

        <el-dialog
            title="新建团体诉求"
            :visible.sync="dialogVisible"
            width="480px"
            center
            :before-close="handleClose">
           <div class="ruleContent">
            <div class="item">
                <label>预约主题</label>
                <el-select v-model="diaParam.ConsultTheme" placeholder="请选择主题" filterable  class="autowidth" clearable >
                    <el-option v-for="item in theme" :label="item" :value="item"></el-option>
                </el-select>
            </div>
            <div class="item">
                <label>有效时间</label>
                <el-date-picker    
                    class="autowidth"
                    clearable
                    v-model="AddTime"
                    type="datetimerange"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                    </el-date-picker>
            </div>
            <div class="item">
                <label>人数限制</label>
                <el-select v-model="diaParam.PeopleNum" placeholder="请选择人数" filterable  class="autowidth" clearable >
                    <el-option v-for="(item,index) in People" :label="item" :value="item"></el-option>
                </el-select>
            </div>
            <div class="item">
                <label>场次价格</label>
                <el-input v-model="diaParam.ServicePrice" placeholder="请输入实际售价" class="autowidth" clearable></el-input>
            </div>
            <div class="item">
                <label>优惠折扣</label>
                <el-input v-model="diaParam.Discount" placeholder="例如8.8折" class="autowidth" clearable></el-input>
            </div>
            
           </div>
            <div style="text-align: center;margin: 20px 0 10px;">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="save()">{{diaParam.RequestKey==''?'保存':'修改'}}</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
export default{
    data() {
        return {
            loading:false,
            Finalpaymenttime:[],
            AddTime:[],
            theme:['心理测评','心理咨询（访谈）','授课','团体辅导'],
            param:{
                pageIndex:1,
                pageSize:10,
                PageTotal:0,
                Name:'',
                StartDate: "",
                EndDate: ""
            },
            GroupdemandsData:[],
            MemeberPackageData:[],
            dialogVisible:false,
            userID:JSON.parse(sessionStorage.getItem('xinxi')).UserID,
            People:['2-3','3-5','5-8','8-12','12-16','16-20','20-30'],
            diaParam:{
                userID:'',
                RequestKey:'',
                ConsultTheme:"",
                PeopleNum:"",
                ServicePrice:"",
                Discount:"",
                StartDate:"",
                EndDate:"" 
            }
        }
    },
    watch:{
        Finalpaymenttime(newval,oldval){
            if(newval==null){
                this.param.StartDate=''
                this.param.EndDate=''
            }else{
                this.param.StartDate=newval[0]
                this.param.EndDate=newval[1]
            }
        },
        AddTime(newval){
            if(newval==null){
                this.diaParam.StartDate=''
                this.diaParam.EndDate=''
            }else{
                this.diaParam.StartDate=newval[0]
                this.diaParam.EndDate=newval[1]
            }
        },
        'diaParam.ServicePrice'(newval,oldval){
            if(newval<0){
                this.diaParam.ServicePrice=0;
            }
        },
        'diaParam.Discount'(newval,oldval){
            if(newval<0){
                this.diaParam.Discount=0;
            }
        }
    },
    mounted() {
        this.diaParam.userID=this.userID;
        this.init();
    },
    methods:{
        init(){
            this.loading=true;
            this.$Http_Post('/GroupClients/PostGroupClientsList',this.param).then(res=>{
                this.loading=false;
                if(res.Code==0 || res.Code==200){
                    this.param.PageTotal=res.Counts;
                    this.GroupdemandsData=res.Data;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        reset(){
            this.param=this.$options.data().param;
            this.init();
        },
        handleinitialization(val){
            this.param.pageIndex=val;
            this.init();
        },
        // 编辑
        ClickAudit(val){
            this.AddTime=[val.startDate,val.endDate];
            this.diaParam={
                userID:this.userID,
                RequestKey:val.requestKey,
                ConsultTheme:val.consultTheme,
                PeopleNum:val.peopleNum,
                ServicePrice:val.servicePrice,
                Discount:val.discount,
                StartDate:val.startDate,
                EndDate:val.endDate 
            };
            this.dialogVisible=true;
        },
        // 新增
        save(){
            let url=this.diaParam.RequestKey==''?'/GroupClients/PostAddGroupClients':'/GroupClients/PostUpdateGroupClients';
            this.diaParam.userID=this.userID;
            this.$Http_Post(url,this.diaParam).then(res=>{
                if(res.Code==0 || res.Code==200){
                    this.diaParam=this.$options.data().diaParam;
                    this.AddTime=[];
                    this.init();
                    this.dialogVisible=false;
                    this.$message.success(res.Message);
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        // 删除
        confirm(val){
            this.$Http_Post('/GroupClients/PostDeleteGroupClients',{RequestKey:val.requestKey}).then(res=>{
                if(res.Code==0 || res.Code==200){
                    this.init();
                    this.$message.success(res.Message);
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        handleClose(){
            this.dialogVisible=false;
        }
    },
}
</script>
<style scoped>
.Groupclients .header{background: #fff;padding:20px;}
.Groupclients .header .headerlabel{width:90px;display: inline-block;}
.Groupclients .autowidth{width: 240px;}
.Groupclients .MainContent{background: #fff;padding:20px 16px;margin:16px 0;}
.Groupclients .ruleContent {margin: 0 20px;}
.Groupclients .ruleContent .item{padding-top: 15px;}
.Groupclients .ruleContent .item label{margin-right: 15px;width: 70px;display: inline-block;}
</style>